import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItem {
  title: string;
  content: string;
}
interface AccordionProps {
  items: AccordionItem[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="space-y-4" data-id="element-20">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className={`border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-brand-clay bg-brand-ivory shadow-md' : 'border-brand-pistachio bg-white hover:border-brand-eucalyptus'}`} data-id="element-21">
            <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-22">
              <span className={`font-serif font-bold text-lg ${isOpen ? 'text-brand-clay' : 'text-brand-dark'}`} data-id="element-23">
                {item.title}
              </span>
              {isOpen ? <ChevronUp className="h-5 w-5 text-brand-clay" data-id="element-24" /> : <ChevronDown className="h-5 w-5 text-brand-text" data-id="element-25" />}
            </button>
            <div className={`transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-26">
              <div className="px-6 pb-6 text-brand-text leading-relaxed" data-id="element-27">
                {item.content}
              </div>
            </div>
          </div>;
    })}
    </div>;
}